import { createSDKClient } from '@learnforge/sdk/client';
import type { LearnForgeSDK } from '@learnforge/sdk';

let cached: LearnForgeSDK | null = null;

export function getSDK(): LearnForgeSDK {
  if (!cached) cached = createSDKClient();
  return cached;
}
